import { render, staticRenderFns } from "./TaxClearanceCertificateForm.vue?vue&type=template&id=34b89b36"
import script from "./TaxClearanceCertificateForm.vue?vue&type=script&lang=js"
export * from "./TaxClearanceCertificateForm.vue?vue&type=script&lang=js"
import style0 from "./TaxClearanceCertificateForm.vue?vue&type=style&index=0&id=34b89b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports